import { ProfipayCardStates } from "@/components/cards/scripts";

const isCardActive = (cardNumber: number, cardStates: ProfipayCardStates[]) => {
  const item = cardStates.find(element => element.number === cardNumber);
  return item?.isActive ?? false;
}

export {
  isCardActive
}
